exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Lne-a32gJPsbKniBCASJm .ms-Suggestions-closeButton{width:36px}html[dir] .Lne-a32gJPsbKniBCASJm .ms-Suggestions-closeButton:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}", ""]);
// Exports
exports.locals = {
	"containsCustomMaskRecipientButton": "Lne-a32gJPsbKniBCASJm"
};